import React from "react";
import $events from '../../../blocs/EventBloc';

export default class RoomSwitchContent extends React.Component {
    constructor( props ) {
        super(props);
    }

    onSwitchBtnPress = (e) => {
        e.preventDefault();
        e.stopPropagation();

        $events.$emit('room/switch', this.props.currentState.obj);
    }

    render() {
        return (
            <div>
                <h3 className="bottom-modal__title">
                    Raum wechseln
                </h3>

                <div className="">
                    <div className="room-switch__image">
                        <img src={this.props.currentState.obj.thumbnailUrl} alt={this.props.currentState.obj.title}/>

                        <div className="room-switch__image-title">
                            <span>{this.props.currentState.obj.title}</span>
                        </div>
                    </div>

                    <p className="copy  [ margin__bottom--small ]">
                        {this.props.currentState.obj.excerpt  && <span>
                            {this.props.currentState.obj.excerpt}
                        </span>}

                        {!(this.props.currentState.obj.excerpt) && <span>
                            Hier geht es zum Raum: '{ this.props.currentState.obj.title }'.
                        </span>}
                    </p>

                    <button className="[ button  button--large ]  [ w--100 ]" onClick={(ev) => this.onSwitchBtnPress(ev)}>
                        Zu '{ this.props.currentState.obj.title }' wechseln
                    </button>
                </div>
            </div>
        );
    }

}
